import { getAmpConfig } from 'shared/config/amp-config';

export const getClassStatsUrl = () =>
  `${getAmpConfig().gateway}/class-stats-svc`;

export const getTaughtLessonsUrl = () =>
  `${getClassStatsUrl()}/classes/batch-get/events/taught`;
